module.exports = __webpack_public_path__ + "media/s3_v1.7cfadb98.mp4";